import React from "react"

import Navbar from "./navbar"
import Footer from "./footer"
import Announcement from "./announcement"

const Layout = ({ children }) => {
  return (
    <React.Fragment>
      <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
        <Announcement />
        <Navbar />
        {children}
        <div className="flex-grow-1" />
        <Footer />
      </div>
    </React.Fragment>
  )
}

export default Layout
